import { render, staticRenderFns } from "./popup-new-task.vue?vue&type=template&id=71c67cdb"
import script from "./popup-new-task.vue?vue&type=script&lang=js"
export * from "./popup-new-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports